import React, { useEffect, useState } from "react";
import s from "./createPayment.module.css";

//assets
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import AgencyModal from "../../../Shared/AgencyModal";
import GamesModal from "../../../Shared/GamesModal";
import masiveDistributionServices from "../../../../api/delivery/masiveDistribution";
import prizesService from "../../../../api/delivery/prizesService";

//MaterialUi
import Grid from "@mui/material/Grid"
import Select from "@mui/material/Select"
import MenuItem from "@mui/material/MenuItem"
import TextField from "@mui/material/TextField"
import Button from "@mui/material/Button"
import CircularProgress from "@mui/material/CircularProgress"
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ReplayIcon from "@mui/icons-material/Replay";
import gamesService from "../../../../api/games/GamesService";
import useTranslationException from "../../../../helpers/exceptions";

const CreatePayment = ({ edit, setEdit, getData }) => {
  const { t, i18n } = useTranslation();
  const showExpetion = useTranslationException(t, i18n);
  const [games, setGames] = useState([]);
  const [loadingGames, setLoadingGames] = useState(false);
  const [errorGames, setErrorGames] = useState(false);

  const dispatch = useDispatch();

  const { activeOrganization } = useSelector((state) => state.gamma);
  const [loading, setLoading] = useState(false);
  const [agencySelected, setAgencySelected] = useState(null);
  const [gameSelected, setGameSelected] = useState(null);
  const [productSelected, setProductSelected] = useState(null);
  const [gameKind, setGameKind] = useState("number");
  const [modalOpen, setModalOpen] = useState(false);
  const [invalidCoupon, setInvalidCoupon] = useState(false);
  const [price, setPrice] = useState("");
  const [modalOpenGames, setModalOpenGames] = useState(false);
  const [form, setForm] = useState({
    id: edit.status ? edit.item.id : null,
    gameId: edit.status ? edit.item.game.id : 0,
    agency: edit.status ? edit.item.agency : null,
    owner: edit.status ? edit.item.agencyHolder : "",
    coupon: edit.status ? edit.item.couponNumber : null,
    raffle: edit.status ? edit.item.raffle.number : 0,
    serie: edit.status ? edit.item.raffle.serie : "",
    amount: edit.status ? edit.item.paymentAmount : 0,
  });

  const getGamesData = () => {
    setLoadingGames(true);
    gamesService
      .getAllGames()
      .then((res) => {
        setGames(res.content);
      })
      .then(() => setLoadingGames(false))
      .catch(() => {
        setLoadingGames(false);
        setErrorGames(true);
      });
  };

  useEffect(() => {
    getGamesData();
  }, []);

  useEffect(() => {
    if (edit.status) {
      if (games.length) {
        handleChangeGame(edit.item?.game?.id);
        setProductSelected(edit.item?.raffle);
      }
      setAgencySelected(edit.item?.agency);
    }
  }, [games, edit.status]);

  useEffect(() => {
    if (agencySelected !== null) {
      setForm((prev) => ({
        ...prev,
        agency: `${agencySelected.number} - ${agencySelected.subNumber}`,
        owner: agencySelected?.currentHolder?.holder?.name,
      }));
    }
  }, [agencySelected]);

  useEffect(() => {
    const game = games.find((g) => g?.modality?.game?.id === form.gameId);
    setGameSelected(game);

    if (game?.modality?.mode?.id !== 1) {
      setForm((prev) => ({
        ...prev,
        raffle: 0,
      }));
    }
    if (form?.coupon?.length >= 18 && gameSelected?.modality?.mode?.id === 1) {
      let barRaffle = form.coupon.slice(0, 4);
      let barCoupon = form.coupon.slice(4, 11);
      setProductSelected({ number: barRaffle });
      setForm((prev) => ({
        ...prev,
        coupon: barCoupon,
        raffle: barRaffle,
      }));
    }
  }, [form.coupon, gameSelected]);

  const handleBack = () => {
    Swal.fire({
      title: t("formExitTitle"),
      text: t("formExitHtml"),
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#00A36C",
      cancelButtonColor: "#d33",
      confirmButtonText: t("accept"),
      cancelButtonText: t("cancel"),
    }).then((result) => {
      if (result.isConfirmed) {
        setEdit({
          create: false,
          status: false,
          item: {},
        });
      }
    });
  };

  const handleChangeGame = (v) => {
    let id = v;
    let game = games.find((item) => item.modality.game.id === id);

    setGameSelected(game);
    setForm((prev) => ({ ...prev, gameId: id }));
  };

  const handleProccess = () => {
    setLoading(true);

    const payload = {
      id: edit.status ? form.id : null,
      raffleId: productSelected.id,
      agencyId: agencySelected.id,
      couponNumber: form.coupon * 1,
      organizationId: activeOrganization.id,
    };
    !edit.status
      ? productSelected.number
        ? masiveDistributionServices
          .createWinnerCouponPreimpreso(payload)
          .then((res) => {
            Swal.fire({
              icon: "success",
              title: t("createCouponSuccessTitle"),
              html: "",
            });
            setLoading(false);
            setEdit({
              create: false,
              status: false,
              item: {},
            });
            getData();
          })
          .catch((e) => {
            showExpetion.showErrorModalForServiceException(
              e,
              { icon: "warning" },
              t("couponNumberError"),
              t("sorryErrorOcurred"),
            );
            setLoading(false);
          })
        : masiveDistributionServices
          .createWinnerCouponInstantaneo(payload)
          .then((res) => {
            Swal.fire({
              icon: "success",
              title: t("createCouponSuccessTitle"),
              html: "",
            });
            setLoading(false);
            setEdit({
              create: false,
              status: false,
              item: {},
            });
            getData();
          })
          .catch((e) => {
            showExpetion.showErrorModalForServiceException(
              e,
              { icon: "warning" },
              t("couponNumberError"),
              t("sorryErrorOcurred"),
            );
            setLoading(false);
          })
      : productSelected.number
        ? masiveDistributionServices
          .modifyWinnerCouponPreimpreso(payload)
          .then((res) => {
            Swal.fire({
              icon: "success",
              title: t("editCouponSuccessTitle"),
              html: "",
            });
            setLoading(false);
            setEdit({
              create: false,
              status: false,
              item: {},
            });
            getData();
          })
          .catch((e) => {
            showExpetion.showErrorModalForServiceException(
              e,
              { icon: "warning" },
              t("couponNumberError"),
              t("sorryErrorOcurred"),
            );
            setLoading(false);
          })
        : masiveDistributionServices
          .modifyWinnerCouponInstantaneo(payload)
          .then((res) => {
            Swal.fire({
              icon: "success",
              title: t("editCouponSuccessTitle"),
              html: "",
            });
            setLoading(false);
            setEdit({
              create: false,
              status: false,
              item: {},
            });
            getData();
          })
          .catch((e) => {
            showExpetion.showErrorModalForServiceException(
              e,
              { icon: "warning" },
              t("couponNumberError"),
              t("sorryErrorOcurred"),
            );
            setLoading(false);
          });
  };

  return (
    <Grid container item xs={12} className={s.container}>
      <Grid item xs={10} className={s.titleContainer}>
        <ArrowBackIcon
          sx={{ color: "primary.main", fontSize: "2.2rem" }}
          onClick={
            edit.status
              ? () => {
                setEdit({
                  create: false,
                  status: false,
                  item: {},
                });
              }
              : handleBack
          }
          className={s.arrow}
        />
        <h4>{edit.status ? t("editPaidCoupons") : t("loadPaidCoupons")}</h4>
      </Grid>

      <Grid item container xs={10} className={s.form}>
        <Grid item container xs={5}>
          <p>{t("game")}</p>
          {loadingGames ? (
            <Grid item xs={12}>
              <CircularProgress size="2.3rem" />
            </Grid>
          ) : errorGames ? (
            <Grid
              item
              xs={12}
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                mt: 1,
              }}
            >
              <p style={{ fontSize: "1rem" }}>{t("noGamesDataAvailable")}</p>
              <ReplayIcon
                onClick={() => {
                  setErrorGames(false);
                  getGamesData();
                }}
                color="primary"
                sx={{ ml: 1, fontSize: "2rem" }}
                className={s.icon}
              />
            </Grid>
          ) : (
            <Grid item xs={12}>
              <Select
                value={form.gameId}
                onChange={(e) => handleChangeGame(e.target.value)}
                sx={{ width: "90%" }}
              >
                <MenuItem value={0}>{t("select")}</MenuItem>
                {games.map((item, i) => (
                  <MenuItem key={i} value={item?.modality?.game?.id}>
                    {item?.modality?.game?.name}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
          )}
        </Grid>
        <Grid item xs={5} className={s.barcode}>
          <p>{`${t("gameKind")}`}</p>
          <TextField
            disabled
            value={gameSelected?.modality?.mode?.name}
            sx={{ width: "90%" }}
          />
        </Grid>
        {gameSelected?.modality?.mode?.name.toLowerCase() === "instantaneo" ? (
          <Grid item xs={5}>
            <p>{t("serie")}</p>
            <TextField
              type={"text"}
              value={productSelected?.serie}
              disabled
              onChange={(e) =>
                setForm((prev) => ({
                  ...prev,
                  serie: e.target.value,
                  raffle: 0,
                }))
              }
              sx={{ width: "62%" }}
            />
            <Button
              variant="contained"
              onClick={() => {
                setModalOpenGames(true);
                setGameKind("serie");
              }}
              sx={{ mb: "10px", ml: "15px", mt: "10px", alignSelf: "flex-end" }}
            >
              {t("consult")}
            </Button>
          </Grid>
        ) : (
          <Grid item xs={5}>
            <p>{t("drawNumber")}</p>
            <TextField
              type={"number"}
              value={productSelected?.number}
              disabled
              onChange={(e) =>
                setForm((prev) => ({
                  ...prev,
                  raffle: e.target.value,
                  serie: "",
                }))
              }
              sx={{ width: "62%" }}
            />
            <Button
              variant="contained"
              onClick={() => {
                if (gameSelected) {
                  setModalOpenGames(true);
                  setGameKind("number");
                } else {
                  Swal.fire({
                    icon: "error",
                    title: t("pleaseSelectGame"),
                  });
                }
              }}
              sx={{ mb: "10px", ml: "15px", mt: "10px", alignSelf: "flex-end" }}
            >
              {t("consult")}
            </Button>
          </Grid>
        )}
        <Grid item xs={5} className={s.barcode}>
          <p>{`${t("coupon")}/${t("codebar")}`}</p>
          <TextField
            type="number"
            value={form.coupon}
            sx={{ width: "90%" }}
            onChange={(e) =>
              setForm((prev) => ({ ...prev, coupon: e.target.value }))
            }
            inputProps={{
              onBlur: (e) => {
                if (gameSelected && productSelected && form?.coupon) {
                  prizesService
                    .verifyWinnerCoupon(
                      form?.coupon,
                      form?.gameId,
                      productSelected?.number || null,
                      productSelected?.serie || null,
                    )
                    .then((res) => {
                      setPrice(res.prizeValue);
                      setInvalidCoupon(false);
                    })
                    .catch((e) => {
                      showExpetion.showErrorModalForServiceException(
                        e,
                        { icon: "warning" },
                        t("couponNumberError"),
                        t("retry"),
                      );
                      setLoading(false);
                    });
                }
              },
            }}
          />
        </Grid>

        <Grid item xs={5}>
          <p>{t("payingAgency")}</p>
          <TextField
            value={edit?.status ? form?.agency?.number : agencySelected?.number}
            onChange={(e) =>
              setForm((prev) => ({ ...prev, agency: e.target.value }))
            }
            sx={{ width: "62%" }}
          />
          <Button
            variant="contained"
            disabled={!productSelected?.id}
            onClick={() => setModalOpen(true)}
            sx={{ mb: "10px", ml: "15px", mt: "10px", alignSelf: "flex-end" }}
          >
            {t("consult")}
          </Button>
        </Grid>

        <Grid item xs={5}>
          <p>{t("owner")}</p>
          <TextField
            value={edit?.status ? form?.agency?.name : agencySelected?.name}
            disabled
            sx={{ width: "90%" }}
          />
        </Grid>
        <Grid item xs={5}>
          <p>{t("prize")}</p>
          <TextField
            value={`$ ${edit?.status ? form?.amount : price}`}
            disabled
            onChange={(e) =>
              setForm((prev) => ({ ...prev, amount: e.target.value }))
            }
            sx={{ width: "90%" }}
          />
        </Grid>
        <Grid item xs={5} sx={{ alignSelf: "flex-end" }}>
          <Button
            onClick={handleProccess}
            variant={loading ? "" : "contained"}
            disabled={
              !(
                form.gameId &&
                form.coupon &&
                form.agency &&
                productSelected &&
                !invalidCoupon
              )
            }
            className={s.send}
          >
            {loading ? (
              <CircularProgress />
            ) : edit.status ? (
              `${t("edit")} ${t("coupon")}`
            ) : (
              t("loadCoupon")
            )}
          </Button>
        </Grid>
      </Grid>
      {modalOpen ? (
        <AgencyModal
          open={modalOpen}
          setOpen={setModalOpen}
          selectAgency={setAgencySelected}
        />
      ) : null}
      {modalOpenGames ? (
        <GamesModal
          open={gameSelected && modalOpenGames}
          setOpen={setModalOpenGames}
          selectGame={setProductSelected}
          modeId={gameSelected?.modality?.mode?.id}
          gameId={gameSelected?.modality?.game?.id}
          type={gameKind}
        />
      ) : null}
    </Grid>
  );
};

export default CreatePayment;
